import { useEffect, useState } from "react";
import { AdminHeader } from "@trillion/ui/components/admin/admin-header";
import { PageHeader } from "@trillion/ui/components/admin/page-header";
import { StatCard } from "@trillion/ui/components/admin/stat-card";
import { Card } from "@trillion/ui/components/ui/card";
import { Skeleton } from "@trillion/ui/components/ui/skeleton";
import { Users } from "lucide-react";
import { adminApi } from "@/lib/admin-api";
import type { UserStats } from "@/types";

export function DashboardPage() {
  const [stats, setStats] = useState<UserStats | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchStats() {
      try {
        const data = await adminApi.users.stats();
        setStats(data);
      } catch {
        // Stats will remain null, show fallback
      } finally {
        setIsLoading(false);
      }
    }
    fetchStats();
  }, []);

  return (
    <div className="flex flex-col">
      <AdminHeader title="Dashboard" />
      <div className="flex flex-col gap-6 p-6">
        <PageHeader
          title="Dashboard"
          description="Overview of the Passport identity system."
        />

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {isLoading ? (
            <>
              {Array.from({ length: 3 }).map((_, i) => (
                <Card key={i} className="p-6">
                  <Skeleton className="h-4 w-24 mb-2" />
                  <Skeleton className="h-8 w-16 mb-1" />
                  <Skeleton className="h-3 w-32" />
                </Card>
              ))}
            </>
          ) : (
            <>
              <StatCard
                title="Total Users"
                value={stats?.total ?? 0}
                description="Registered across all products"
                icon={<Users />}
              />
              <StatCard
                title="Identity Provider"
                value="Passport"
                description="Centralized SSO for Trillion products"
              />
              <StatCard
                title="Auth Modes"
                value="3"
                description="Passport-only, Local-only, Hybrid"
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
